import { useState } from "react";
import { Facebook, Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const SITE_URL = "https://bookthebarberschair.com";

export default function ShareButtons({ url = SITE_URL, text = "Just booked a fresh cut at The Barbers Chair — book yours online:", label = "Loved it? Spread the word" }) {
  const [copied, setCopied] = useState(false);

  const shareFacebook = () => {
    const u = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`;
    window.open(u, "_blank", "noopener,noreferrer,width=600,height=500");
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "The Barbers Chair", text, url });
      } catch { /* user cancelled */ }
    } else {
      copyLink();
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      toast.success("Link copied — paste it anywhere!");
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div data-testid="share-buttons">
      {label && <p className="overline text-[0.6rem] text-white/50 mb-3">{label}</p>}
      <div className="flex items-center justify-center gap-3">
        <button
          onClick={shareFacebook}
          className="group inline-flex items-center gap-2 border border-white/20 px-5 py-2.5 overline text-[0.6rem] text-white hover:border-[#1877F2] hover:text-[#1877F2] transition-colors"
          data-testid="share-facebook-btn"
        >
          <Facebook className="w-4 h-4" strokeWidth={1.5} /> Facebook
        </button>
        <button
          onClick={nativeShare}
          className="group inline-flex items-center gap-2 border border-white/20 px-5 py-2.5 overline text-[0.6rem] text-white hover:border-[#d4af37] hover:text-[#d4af37] transition-colors"
          data-testid="share-native-btn"
        >
          <Share2 className="w-4 h-4" strokeWidth={1.5} /> Share
        </button>
        <button
          onClick={copyLink}
          className="group inline-flex items-center gap-2 border border-white/20 px-5 py-2.5 overline text-[0.6rem] text-white hover:border-[#d4af37] hover:text-[#d4af37] transition-colors"
          data-testid="share-copy-btn"
        >
          {copied ? <Check className="w-4 h-4 text-[#d4af37]" /> : <Copy className="w-4 h-4" strokeWidth={1.5} />} {copied ? "Copied" : "Copy Link"}
        </button>
      </div>
    </div>
  );
}
